import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject, catchError, map, throwError } from 'rxjs';
import { TuwaiqUtil } from 'src/app/core/TuwaiqUtil';
import { ApiConstants } from 'src/app/core/constants/api.constants';
import { FilterDetails } from 'src/app/core/models/filter-details.model';

import { ActivatedRoute } from '@angular/router';
import { TuwaiqConfig } from 'src/app/core/constants/tuwaiq.config';
import { AuthService } from 'src/app/core/services/auth.service';
import { SessionExpiredComponent } from 'src/app/shared/components/sessionExpired/sessionExpired/session-expired.component';
import { Department } from 'src/app/ticketing-module/util/model/departmen.model';
import { EServicesActionDto } from '../util/service.model';

@Injectable({
    providedIn: 'root'
})
export class ServiceModuleService {
    filterServiceList = new BehaviorSubject<FilterDetails[]>([]);
    filterDashboardServiceList = new BehaviorSubject<FilterDetails[]>([]);
    filterHistoryFeildsServiceList = new BehaviorSubject<FilterDetails[]>([]);

    resetServiceList = new BehaviorSubject<boolean>(false);
    resetHistoryFeildsServiceList = new BehaviorSubject<boolean>(false);
    reloadSideMenuCount = new BehaviorSubject<boolean>(false);
    currentStatusId = new BehaviorSubject<string>('');
    isExpiredSession: any;
    fetchNextPage = new Subject<number>();
    showTableLoader = new Subject<boolean>();
    scrollToTop = new Subject<boolean>();
    statusId!: string;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
        this.getStatusParam();
    }

    public getAllDepartments(): Observable<Department[]> {
        return this.http.get(ApiConstants.All_DEPARTMENTS).pipe(map((response: { data: Department[]; meta: any }) => response.data));
    }

    public getCountsideMenu() {
        const api = ApiConstants.TOTAL_SERVICE_COUNT_Ticketing;
        return this.http.get(api).pipe(
            map(response => {
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    public getServiceDetailsById(serviceId, params?: HttpParams) {
        const api = ApiConstants.SERVICE_DETAILS.replace('{serviceId}', serviceId);
        return this.http.get(api, { params: params }).pipe(
            map(response => {
                TuwaiqUtil.convertKeysToCamelCase(response);
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    saveService(service, isDelegate?: boolean) {
        let api = ApiConstants.SAVE_SERVICE;
        api = api.replace('{delegate}', isDelegate.toString());
        return this.http.post(api, service).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }

    /** Error Handling method */
    errorHandler(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            // this.authService.logout()
            this.handleSessionExpired();
        } else if (errorResponse.error && errorResponse.error['errors']) {
            return throwError(() => errorResponse.error['errors'][0]);
        }
        return throwError(() => 'An error occurred; please try again later.');
    }

    //TEMP:
    errorListHandler(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            // this.authService.logout()
            this.handleSessionExpired();
        } else if (errorResponse.error && errorResponse.error['errors']) {
            return throwError(() => errorResponse.error['errors']);
        }
        return throwError(() => 'An error occurred; please try again later.');
    }

    handleSessionExpired() {
        if (!this.isExpiredSession) {
            this.dialog.open(SessionExpiredComponent, {
                width: '412px',
                disableClose: true
            });
            this.isExpiredSession = true;
        }
    }
    getServicesListBySearchFilter(parameters?: HttpParams) {
        let api = ApiConstants.LIST_E_SERVICES_MODULE_BY_SEARCH;
        return this.http.get(api, { params: parameters, observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    getHistoryFeildServicesListBySearchFilter(parameters?: HttpParams, ticketId?: string) {
        let api = ApiConstants.HISTORY_FELD_LIST_E_SERVICES_MODULE_BY_SEARCH.replace('{ticketId}', ticketId);
        return this.http.get(api, { params: parameters, observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    getRequesterList(parameters?: HttpParams) {
        let api = ApiConstants.LIST_REQUESTER;

        return this.http.get(api, { params: parameters, observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    getStatusList(parameters?: HttpParams) {
        let api = ApiConstants.LIST_STATUS;

        return this.http.get(api, { params: parameters, observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    deleteEService(serviceId: string) {
        const api = ApiConstants.DELETE_SERVICE.replace('{serviceId}', serviceId);
        return this.http.delete(api, {}).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }

    approveEService(ticketId: string, eServicesItems: EServicesActionDto, isDelegate?: boolean) {
        let api = ApiConstants.APPROVE_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{delegate}', isDelegate.toString());
        return this.http.put(api, eServicesItems).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    resolveEService(ticketId: string, isResolutionTeam: string, eServicesItems: EServicesActionDto, isDelegate?: boolean) {
        let api = ApiConstants.CLOSE_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{isResolutionTeam}', isResolutionTeam);
        api = api.replace('{delegate}', isDelegate.toString());

        return this.http.put(api, eServicesItems).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    rejectEService(ticketId: string, isResolutionTeam: string, eServicesItems: EServicesActionDto, isDelegate?: boolean) {
        let api = ApiConstants.REJECTION_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{isResolutionTeam}', isResolutionTeam);
        api = api.replace('{delegate}', isDelegate.toString());
        return this.http.put(api, eServicesItems).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    reassignEService(ticketId: string, userId: string, isDelegate?: boolean) {
        let api = ApiConstants.REASSIGN_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{userId}', userId);
        api = api.replace('{delegate}', isDelegate.toString());

        return this.http.patch(api, {}).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    returnEService(ticketId: string, isResolutionTeam: string, eServicesItems: EServicesActionDto, isDelegate?: boolean) {
        let api = ApiConstants.RETURN_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{isResolutionTeam}', isResolutionTeam);
        api = api.replace('{delegate}', isDelegate.toString());

        return this.http.put(api, eServicesItems).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    checkLastApprovalService(ticketId: string, isDelegate?: boolean) {
        let api = ApiConstants.CHECK_LAST_APPROVAL_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{delegate}', isDelegate.toString());
        return this.http.get(api, { observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    getHistoryEService(ticketId: string) {
        const api = ApiConstants.HISTORY_TICKETING_SERVICE.replace('{ticketId}', ticketId);

        return this.http.get(api, { observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    assignToMeEService(ticketId: string) {
        const api = ApiConstants.ASSIGN_TO_ME_SERVICE.replace('{ticketId}', ticketId);
        return this.http.patch(api, '').pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    cancelEService(ticketId: string, eServicesItems: EServicesActionDto) {
        let api = ApiConstants.CANCEL_SERVICE.replace('{ticketId}', ticketId);
        return this.http.put(api, eServicesItems).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    uploadFilesForEService(fileObject: File) {
        return this.uploadAttachmentUrlForEService(fileObject);
    }

    uploadAttachmentUrlForEService(fileObject: File) {
        const api = ApiConstants.TICKETING_UPLOAD_URL;
        const formData = new FormData();
        formData.append('file', fileObject, fileObject.name);
        formData.append('reportProgress', 'true');
        return this.http.post(api, formData).pipe(
            map(response => {
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    handleAttachmentObject(attachmentList) {
        return attachmentList?.map(attachment => ({
            checksum: TuwaiqConfig.ATTACHMENT_CHECKSUM,
            contentType: attachment.type,
            key: attachment.key,
            name: attachment.name,
            size: attachment.size,
            action: 'create ticket'
        }));
    }
    getStatusParam() {
        this.activatedRoute.queryParamMap.subscribe(params => {
            this.statusId = params.get('status');
        });
    }
    filterStatusList() {
        const statusFilters = {
            ASSIGNED_TO_ME: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.SERVICES_MANAGEMENT,
                    value: 'assignedtome',
                    removeFilter: false
                }
            ],
            SHARED_SERVICES: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.SERVICES_MANAGEMENT,
                    value: 'sharedwithme',
                    removeFilter: false
                }
            ],
            NEED_MY_APPROVAL: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.NEED_MY_APPROVAL,
                    value: true,
                    removeFilter: false
                }
            ],
            NOT_ASSIGNED_TO_ME: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.SERVICES_MANAGEMENT,
                    value: 'notassigned',
                    removeFilter: false
                }
            ],
            RESOLVED_BY_ME: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.SERVICES_MANAGEMENT,
                    value: 'resolvedbyme',
                    removeFilter: false
                }
            ],
            IN_PROGRESS: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.TICKET_STATUS_ID_FILTER,
                    value: ['IN_PROGRESS', 'SM_APPROVAL', 'GM_APPROVAL', 'DIRECTOR_APPROVAL', 'NEED_ASSIGNMENT'],
                    removeFilter: false
                },
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.REQUESTER_BY_ME,
                    value: true,
                    removeFilter: false
                }
            ],
            CLOSED: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.TICKET_STATUS_ID_FILTER,
                    value: ['CLOSED', 'REJECTED'],
                    removeFilter: false
                },
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.REQUESTER_BY_ME,
                    value: true,
                    removeFilter: false
                }
            ],
            DRAFT: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.TICKET_STATUS_ID_FILTER,
                    value: ['DRAFT', 'CANCELLED'],
                    removeFilter: false
                },
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.REQUESTER_BY_ME,
                    value: true,
                    removeFilter: false
                }
            ],
            RETURNED: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.TICKET_STATUS_ID_FILTER,
                    value: this.statusId,
                    removeFilter: false
                },
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.REQUESTER_BY_ME,
                    value: true,
                    removeFilter: false
                }
            ],
            ALL_SERVICES: [], // no filter for all services
            TEAM_SERVICES: [
                {
                    key: TuwaiqConfig.REQUEST_QUERY_PARAMS.TEAM_SERVICES,
                    value: true,
                    removeFilter: false
                }
            ] // no filter for team services
        };
        return statusFilters[this.statusId];
    }

    shareTicketWithMember(ticketId: string, payload) {
        const api = ApiConstants.SHARE_SERVICE_TICKET.replace('{ticketId}', ticketId);
        return this.http.put(api, payload).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }

    shareTicketWithResolutionMember(ticketId: string) {
        const api = ApiConstants.SHARE_TICKET_WITH_RESOLUTION.replace('{ticketId}', ticketId);
        return this.http.put(api, null).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }

    getDelegateUsers(ticketId: string, isDelegate?: boolean) {
        let api = ApiConstants.DELEGATE_USERS.replace('{ticketId}', ticketId);
        api = api.replace('{delegate}', isDelegate.toString());
        return this.http.get(api, { observe: 'response' }).pipe(
            map(response => {
                const responseData = response;
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return responseData;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    delegateTicket(ticketId: string, userId: string, isDelegate?: boolean) {
        let api = ApiConstants.DELEGATE_SERVICE.replace('{ticketId}', ticketId);
        api = api.replace('{userId}', userId);
        api = api.replace('{delegate}', isDelegate.toString());
        return this.http.put(api, {}).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    deleteDelegate(ticketId: string) {
        const api = ApiConstants.DELETE_DELEGATE.replace('{ticketId}', ticketId);
        return this.http.put(api, {}).pipe(
            map(response => {
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
}
